import React from 'react';
import { GALLERY } from './gallery';

// Teaser „Z życia pasieki": duże zdjęcie (szyld) z podpisem, pod nim brief
// i przycisk prowadzący do pełnej galerii (#galeria).
const ApiarySection = React.memo(function ApiarySection({ addToRefs }) {
  const photo = GALLERY.find((item) => item.id === 'tabliczka');

  return (
    <section className="apiary-section" id="pasieka">
      <div className="apiary-header reveal" ref={addToRefs}>
        <h2>Z życia pasieki</h2>
        <div className="premium-line-divider"></div>
      </div>

      <div className="apiary-body reveal" ref={addToRefs}>
        {photo && (
          <div className="apiary-photo-frame">
            <img
              className="apiary-photo"
              src={photo.full}
              srcSet={`${photo.thumb} 800w, ${photo.full} 1600w`}
              sizes="(max-width: 900px) 90vw, 620px"
              alt={photo.alt}
              loading="lazy"
              decoding="async"
            />
          </div>
        )}
        <div className="apiary-text">
          <p>
            Przytulną Pasiekę prowadzimy z pasji do pszczół. To małe, lokalne
            gospodarstwo – każdy słoik wypełniamy sami, zbierając miód
            z własnych uli bez pośpiechu i na własnych zasadach.
          </p>
          <p>
            Zobaczcie, jak wygląda nasza codzienność: od zaglądania do uli
            po tradycyjne miodobranie.
          </p>
          <a href="#galeria" className="apiary-btn">Zobacz galerię</a>
        </div>
      </div>
    </section>
  );
});

export default ApiarySection;
